module.exports = __webpack_public_path__ + "static/media/izmeritelnye_preobrazovateli_ovkz.9613c688.pdf";